import Home from './components/Home/App.vue'
import Consulting from './components/Consulting/App.vue'

const routes = [
  { path: '/', component: Home, name: 'INNOVATION ♦ FINANCIAL ♦ TECHNOLOGY | FINNX' },
  { path: '/consulting', component: Consulting, name: 'ยกระดับธุรกิจของคุณ โดยผู้เชี่ยวชาญที่อยู่เบื้องหลังการเติบโตขององค์กรชั้นนำ | FINNX Consulting Group' },
]

export default routes